<template>
  <v-tooltip bottom max-width="350">
    <span>{{ tooltip }}</span>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        :size="size"
        v-bind="attrs"
        v-on="on"
        style="vertical-align: baseline"
        >{{ icon }}</v-icon
      >
    </template>
  </v-tooltip>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, toRefs } from "vue"
import useTranslate from "features/common/translate/concerns/useTranslate"
import { EventNonmemberAccessEnum } from "suus-api"
import { mdiLock, mdiShieldCheck } from "@mdi/js"

export default defineComponent({
  name: "AccessIcon",
  props: {
    itemType: {
      type: String,
      required: true,
    },
    isMemberInGroup: { type: Boolean, required: true },
    groupName: { type: String, required: true },
    nonmemberAccess: {
      type: String as PropType<EventNonmemberAccessEnum>,
      required: true,
    },
    hidden: { type: Boolean, required: true },
    size: { type: [String, Number], default: "16" },
  },
  setup(props) {
    const { itemType, isMemberInGroup, groupName, nonmemberAccess, hidden } =
      toRefs(props)

    const { t$ } = useTranslate("forum_items.access_icon")
    const type = computed(() =>
      itemType.value === "ForumTopic" ? "topic" : "event"
    )
    const readonlyTitle = computed(() => {
      const writePermissionNote =
        !isMemberInGroup.value && nonmemberAccess.value !== "write"
          ? "Du darfst hier nur mitlesen."
          : "Du darfst mitdiskutieren."

      const groupNameI18n = t$(`.${type.value}.readonly`, {
        group_name: groupName.value,
      })

      return `${groupNameI18n} ${writePermissionNote}`
    })

    const tooltip = computed(() => {
      if (hidden.value) {
        return t$(`.${type.value}.hidden_group`)
      } else if (nonmemberAccess.value === "read") {
        return readonlyTitle.value
      } else {
        return t$(`.${type.value}.hidden`, { group_name: groupName.value })
      }
    })

    const icon = computed(() => {
      if (hidden.value || nonmemberAccess.value === "hidden") {
        return mdiShieldCheck
      } else if (nonmemberAccess.value === "read") {
        return mdiLock
      } else {
        return mdiLock
      }
    })

    return { t$, icon, tooltip }
  },
})
</script>
